import { LoginBackground } from "components/web-checkout/login-background/login-background";
import ProfileCreated from "components/web-checkout/profile-created-modal/profile-created";
import { StudentDataConfirmation } from "components/web-checkout/student-data-confirmation/student-data-confirmation";
import { useUserDetails } from "hooks/use-user-details/use-user-details";
import { useRouter } from "next/router";

const UserDetailsPage = (): JSX.Element => {
  const router = useRouter();
  const {
    studentData,
    parentData,
    handleUpdateUserProfile,
    handleUpdate,
    isSuccess,
    isLoading
  } = useUserDetails();

  const handleConfirmAll = () => {
    handleUpdateUserProfile();
    sessionStorage.removeItem("updateUserFormData");
    sessionStorage.removeItem("originalUserFormData");
    sessionStorage.removeItem("hasShownUpdateToast");
  };

  const handleProfileCreated = () => {
    router.push("/bimbel");
  };

  return (
    <LoginBackground routerPath={router.pathname}>
      {isSuccess && <ProfileCreated onSelectSchedule={handleProfileCreated} />}
      <StudentDataConfirmation
        studentData={studentData}
        parentData={parentData}
        onUpdate={handleUpdate}
        onConfirmAll={handleConfirmAll}
        isLoading={isLoading}
      />
    </LoginBackground>
  );
};

UserDetailsPage.requireAuth = true;
export default UserDetailsPage;
